import packageJson from '../../../../package.json';

const version = packageJson.version;

export const environment = {
  production: false,
  mode: 'dev',
  apiUrl: 'https://backend.staging.piscinapp.com.br',
  platformName: 'android',
  inferencesApiUrl: 'https://ai.piscinapp.com.br',
  webUrl: 'https://dev.piscinapp.com.br',
  version,
};
